import { type Address } from 'viem'

import ofacBlacklist from './ofac-blacklist.json'

export const OFAC_BLACKLIST = ofacBlacklist.map((address) => address.toLowerCase()) as Address[]
